module.exports = __webpack_public_path__ + "assets/images/01-active_4ed78809bb239cbbb95d94b3a5a7a8be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-2/01-active.png
// module id = 233
// module chunks = 0